
import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'


Vue.use(VueI18n);

//国际化
const i18n = new VueI18n({
  locale:"zh",//设置默认语言为中文
  messages: {
    en: {
      ...enLocale,
      ...elementEnLocale// 或者用 Object.assign({ message: 'hello' }, enLocale)
    },
    zh: {
      ...zhLocale,
      ...elementZhLocale// 或者用 Object.assign({ message: '你好' }, zhLocale)
    }
  }
});
export default i18n



// WEBPACK FOOTER //
// ./src/common/lang/index.js